import toast from 'react-hot-toast'
import { httpService } from './http.service.js'

export const cloudinaryService = { uploadImage }

/* הגדרות כלליות */
const ALLOW_VIDEO_UPLOAD = false
const MAX_IMAGE_SIZE_MB = 10
const MAX_VIDEO_SIZE_MB = 100

/**
 * מעלה קובץ תמונה/וידאו ל-backend (POST /api/upload)
 * @param {File} file – קובץ File מ-input
 * @param {Object=} options – { type?: string, relatedId?: string }
 * @returns {Promise<{ imgUrl: string, cached: boolean }>}
 */
async function uploadImage(file, options = {}) {
  const isImage = file.type.startsWith('image/')
  const isVideo = file.type.startsWith('video/')

  if (isVideo && !ALLOW_VIDEO_UPLOAD) {
    const msg = 'העלאת וידאו אינה מותרת כרגע!'
    toast.error(msg)
    throw new Error(msg)
  }

  const MAX_MB = isImage ? MAX_IMAGE_SIZE_MB : isVideo ? MAX_VIDEO_SIZE_MB : 0
  const MAX_SIZE_BYTES = MAX_MB * 1024 * 1024

  if (file.size > MAX_SIZE_BYTES) {
    const msg = `הקובץ גדול מידי! המקסימום עבור ${
      isImage ? 'תמונה' : 'וידאו'
    } הוא ${MAX_MB}MB`
    toast.error(msg)
    throw new Error(msg)
  }

  const formData = new FormData()
  formData.append('img', file)

  // שליחה אופציונלית של type / relatedId
  if (options.type) formData.append('type', options.type)
  if (options.relatedId) formData.append('relatedId', options.relatedId)

  try {
    const res = await httpService.post('upload', formData)
    return res
  } catch (err) {
    console.error('Error uploading via backend:', err)
    const msg = err.response?.data?.error || 'שגיאה בהעלאת הקובץ'
    toast.error(msg)
    throw err
  }
}
